import api from "./core";

const basePath = "api/core/ReleaseOfInformation";

export default {
  getFromDocument(documentId) {
    return api.get(`${basePath}/${documentId}`);
  },
  get(eocId) {
    return api.get(`${basePath}/FindFromEoc/${eocId}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  changeStatus(id) {
    return api.patch(`${basePath}/ChangeStatus/${id}`);
  }
};
